import { render, staticRenderFns } from "./patient.html?vue&type=template&id=dc4bf07e&"
import script from "./patient.js?vue&type=script&lang=js&"
export * from "./patient.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports